import Transformer from './transformer';
import stringUtil from '../utils/stringUtil';
import numberUtil from '../utils/number';
import date from '../utils/dateTime';
import timeSlotUtil from '../utils/timeSlot';
import moment from 'moment-timezone';

export default class VoucherTransformer extends Transformer {
  static fetch(voucher) {
    return {
      id: voucher.id,
      code: voucher.code,
      amount: VoucherTransformer.amount(voucher),
      status: voucher.status,
      genBy: voucher.admin ? voucher.admin.email : '',
      useBy: voucher.user ? voucher.user : null,
      expiration: voucher.expiration,
      voucher_order: voucher.voucher_order_id,
      email: voucher.email,
      support_pin: voucher.support_pin,
      note: voucher.note,
      type: voucher.type,
      transfer_receipt: voucher.transfer_receipt,
      created_at: voucher.created_at,
      updated_at: voucher.updated_at,
    };
  }
  static sendVoucher(voucher) {
    const payload = VoucherTransformer.convertUsernameToEmailOrSupportPin(voucher);
    return payload;
  }

  static convertUsernameToEmailOrSupportPin(voucher) {
    const result = window._.cloneDeep(voucher);
    if (result.username.includes('@')) {
      result.email = result.username;
      result.support_pin = '';
    } else {
      result.support_pin = result.username;
      result.email = '';
    }
    delete result.username;
    return result;
  }

  static convertEmailOrSupportPinToUsername(voucher) {
    const result = window._.cloneDeep(voucher);
    if (result.email) {
      result.username = result.email;
      delete result.email;
    } else {
      result.username = result.support_pin;
      delete result.support_pin;
    }
    return result;
  }

  static convertExpireDateTime(voucher) {
    const result = window._.cloneDeep(voucher);
    if (result.date) {
      result.expire = moment
        .tz(result.date, timeSlotUtil.getLocalTimeZone())
        .endOf('day')
        .tz('UTC')
        .format('Y-MM-DD HH:mm:ss');
      delete result.date;
      delete result.time;
    }
    // console.log(result)
    return result;
  }

  static status(one) {
    return stringUtil.capitalize(one.status);
  }
  static amount(one) {
    return numberUtil.commaWithDecimal(one.amount / 100);
  }
  static created(one) {
    return date.formateDateTimeForDisplay(one.created_at);
  }
  static expiration(one) {
    return date.formateDateTimeForDisplay(one.expiration);
  }
  static voucher_order(one) {
    return one.voucher_order || '-';
  }
  static sentTo(one) {
    if (one.email) return one.email;
    else if (one.support_pin) return 'Support Pin : ' + one.support_pin;
    else return '-';
  }

  static useBy(one) {
    if (one.useBy)
      return `${one.useBy.email ? one.useBy.email : one.useBy.tel} <br>(Support pin : ${one.useBy.support_pin})`;
    else return '-';
  }

  static updated(one) {
    return date.formateDateTimeForDisplay(one.updated_at);
  }
}

export const voucherMixin = {
  methods: {
    status: VoucherTransformer.status,
    amount: VoucherTransformer.amount,
    created: VoucherTransformer.created,
    expiration: VoucherTransformer.expiration,
    voucher_order: VoucherTransformer.voucher_order,
    sentTo: VoucherTransformer.sentTo,
    useBy: VoucherTransformer.useBy,
    updated: VoucherTransformer.updated,
  },
};
